import { render, staticRenderFns } from "./ChipCollection.vue?vue&type=template&id=6b96f7f4&"
import script from "./ChipCollection.vue?vue&type=script&lang=js&"
export * from "./ChipCollection.vue?vue&type=script&lang=js&"
import style0 from "./ChipCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports